export default __webpack_public_path__ + "static/media/futura_logo.cbd93957.svg";